module.exports = __webpack_public_path__ + "static/blumenstecker-pinguin.474f8c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/blumenstecker-pinguin.jpg
// module id = 554
// module chunks = 35783957827783